import Chunklet from 'components/Chunklet/Chunklet';

export default Chunklet;
